import { reportConfig } from '../../../utils/config/tableReportConfig';
import DynamicTable from '../../../components/tables/dynamicTable';
import { getDynamicSelectData } from '../../../utils/api/data';
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import React, { useState, useMemo,  useEffect } from 'react';
import { useLocation } from "react-router-dom";
import './drilldownreport.css';

const reportMapper = {
  'Parcel Invoice': ['total by invoice number', 'total by service', 'total by charge description']
};

const DrillDownReport = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const sections = useMemo(() => {
    return reportName ? reportMapper[reportName] || [] : [];
  }, [reportName]);


  useEffect(() => {
    if (!sections.length) return;
    const fetchAllData = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          sections.map(async (section) => {
            const configData = reportConfig[section.toLowerCase()];
            const result = await getDynamicSelectData(configData);
            return { section, result };
          })
        );
        const dataMap = Object.fromEntries(results.map(({ section, result }) => [section, result]));
        setData(dataMap);
      } catch (error) {
        console.error("Error fetching report data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [sections]);

  return (
    <div className='drillDownReportPage'>
      <div className="LandingContainer">
        <NavBar />
        <Sidebar />
        <div className="PageContent">
          <div className="reportTitle" style={{paddingBottom: '5px'}}>
            <h1>{reportName}</h1>
          </div>
          <div className="reportSpace" style={{padding: '5px'}}>
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                <CircularProgress />
              </div>
            ) : (
            <div className="drillDownReports">
              <div className="leftReport">
                {data && sections?.length > 0 && (
                  <DynamicTable dataObject={{ data: data[sections[0]]}} defaultSize = 'small'/>
                )}
              </div>
              <div className="rightReport">
                {sections?.slice(1).map((section) =>
                  data?.[section] ? (
                    <DynamicTable key={section} dataObject={{ data: data[section] }} defaultSize = 'small'/>
                  ) : null
                )}
              </div>
            </div>
             )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DrillDownReport